// extracted by mini-css-extract-plugin
export default {"addressSection":"CM-z","disabled":"DM-z","sectionButtons":"EM-z","logo":"FM-z"};